import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {TableColumnFilter} from './table-filter.component';
import {TableColumnFilters} from './table-filters.directive';
import {TableColumnHeader} from './table-header.component';
import {TablePaginationComponent} from './table-pagination.component';
import {TableComponent} from './table.component';

import {ApiModule} from '../../api/api.module';
import {PipesModule} from '../../pipes/pipes.module';
import {PlatformModule} from '../platform/platform.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PlatformModule,
    TranslateModule,
    PipesModule,
    ApiModule
  ],
  declarations: [
    TableColumnFilter,
    TableColumnFilters,
    TableColumnHeader,
    TableComponent,
    TablePaginationComponent
  ],
  exports: [
    TableColumnFilter,
    TableColumnFilters,
    TableColumnHeader,
    TableComponent,
    TablePaginationComponent
  ],
  providers: []
})
export class TableModule {
}
